var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Component from 'vue-class-component';
import { namespace } from 'vuex-class';
import { QuestionComponent, QuestionProps } from '@declaration/question';
import RadioPrimaryButton from '@declaration/components/UI/RadioPrimaryButton.vue';
import QuestionPanel from '@declaration/components/UI/QuestionPanel.vue';
import { YES_OR_NO_CHOICES } from '@declaration/helpers/choices';
import { ClaimTypeTrigram } from '@shared/types/api/claim';
const claim = namespace('claim');
const counting = namespace('counting');
const contract = namespace('contract');
const qualification = namespace('qualification');
const settings = namespace('settings');
let HasPersonalPropertyDamagesQuestion = class HasPersonalPropertyDamagesQuestion extends QuestionComponent {
    constructor() {
        super(...arguments);
        this.yesNoQuestionValuesAndTradKeys = YES_OR_NO_CHOICES;
    }
    get selfCareSettings() {
        return this.setting('selfCareSettings');
    }
    updateClaim(hasPersonalPropertyDamages) {
        this.updateAndSaveCounting({
            countingPayload: { hasPersonalPropertyDamages },
            step: this.step,
        });
    }
    get panelTitle() {
        return this.trigram === ClaimTypeTrigram.WaterDamage && this.isTenant
            ? this.$tc('claim.damage.personal_property.has_personal_property_damages.tenant.title')
            : this.$tc('claim.damage.personal_property.has_personal_property_damages.owner.title');
    }
    get sidebarTitle() {
        const key = this.trigram === ClaimTypeTrigram.WaterDamage && this.isTenant
            ? 'claim.damage.personal_property.has_personal_property_damages.tenant.sidebar_title'
            : 'claim.damage.personal_property.has_personal_property_damages.owner.sidebar_title';
        return this.$te(key) ? this.$tc(key) : this.panelTitle;
    }
    get subTitle() {
        if (this.showDescriptionForAllContracts) {
            return this.$tc('claim.damage.personal_property.has_personal_property_damages.description');
        }
        return this.isTenant
            ? this.$tc('claim.damage.personal_property.has_personal_property_damages.tenant.description')
            : null;
    }
    get showDescriptionForAllContracts() {
        var _a, _b, _c, _d, _e;
        return ((_e = (_d = (_c = (_b = (_a = this.selfCareSettings) === null || _a === void 0 ? void 0 : _a.declaration) === null || _b === void 0 ? void 0 : _b.pages) === null || _c === void 0 ? void 0 : _c.hasPersonalPropertyDamagesQuestion) === null || _d === void 0 ? void 0 : _d.showDescriptionForAllContracts) !== null && _e !== void 0 ? _e : false);
    }
    get answer() {
        if (this.counting.hasPersonalPropertyDamages === null) {
            return null;
        }
        return this.counting.hasPersonalPropertyDamages
            ? this.$tc('claim.damage.personal_property.has_personal_property_damages.sumup.yes')
            : this.$tc('claim.damage.personal_property.has_personal_property_damages.sumup.no');
    }
};
__decorate([
    claim.State('isUpdatingClaim')
], HasPersonalPropertyDamagesQuestion.prototype, "isUpdatingClaim", void 0);
__decorate([
    counting.State('counting')
], HasPersonalPropertyDamagesQuestion.prototype, "counting", void 0);
__decorate([
    counting.Action('updateAndSaveCounting')
], HasPersonalPropertyDamagesQuestion.prototype, "updateAndSaveCounting", void 0);
__decorate([
    contract.Getter('isTenant')
], HasPersonalPropertyDamagesQuestion.prototype, "isTenant", void 0);
__decorate([
    qualification.Getter('typeTrigram')
], HasPersonalPropertyDamagesQuestion.prototype, "trigram", void 0);
__decorate([
    settings.Getter('setting')
], HasPersonalPropertyDamagesQuestion.prototype, "setting", void 0);
HasPersonalPropertyDamagesQuestion = __decorate([
    Component({
        components: { RadioPrimaryButton, QuestionPanel },
        props: QuestionProps,
    })
], HasPersonalPropertyDamagesQuestion);
export default HasPersonalPropertyDamagesQuestion;
